import http from '@/utils/http'

/**
 *  首页配置列表
*/
export function getHomeConfigList(params) {
    return http({
        url: '/system/home/page',
        method: 'post',
        data: params
    })
}

/**
 *  首页配置详情
*/
export function getHomeConfigDetail(params) {
    return http({
        url: '/system/home/get',
        method: 'get',
        params
    })
}

/**
 *  添加首页配置
*/
export function addHomeConfig(params) {
    return http({
        url: '/system/home/add',
        method: 'post',
        data: params
    })
}

/**
 *  修改首页配置
*/
export function updateHomeConfig(params) {
    return http({
        url: '/system/home/edit',
        method: 'post',
        data: params
    })
}

/**
 *  删除首页配置
*/
export function delHomeConfig(params) {
    return http({
        url: '/system/home/remove',
        method: 'post',
        params
    })
}

